/**
 * The padding of the page on a phone, as semantic spacing keys. The page applies it, and the
 * sticky action bar negates it to reach the screen's edges, so both read it from here.
 */
export const PHONE_PAGE_PADDING_X = 'base';
export const PHONE_PAGE_PADDING_BOTTOM = '2lg';
